import React, {Component} from 'react';
import RarocHeader from '../Header/Header';
import './OverviewByBranch.style.scss';
import ToiOpexBranch from './components/ToiOpexBranch/ToiOpexBranch';
import ToiStructureBranch from './components/ToiStructureBranch/ToiStructureBranch';
import BalanceAndRwa from './components/BalanceAndRwa/BalanceAndRwa';

export default class OverviewByBranch extends Component {
  render() {
    return (
      <div className='overview-branch-container card'>
        <RarocHeader title={'OVERVIEW DASHBOARD by BRANCH'} />
        <div className='chart-container'>
          <ToiStructureBranch />
          <ToiOpexBranch />
          <BalanceAndRwa />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewByBranch/OverviewByBranch.js